(function() {
    'use strict';

    class SendgridService {
        constructor($q, $http, SENDGRID_ACCOUNT_SERVICE_URL){
            this.$q = $q;
            this.$http = $http;
            this.SENDGRID_ACCOUNT_SERVICE_URL = SENDGRID_ACCOUNT_SERVICE_URL;
        }

        getCompanyDomains() {
            let deferred = this.$q.defer();
            this.$http.get(this.SENDGRID_ACCOUNT_SERVICE_URL + '/domains')
                .then((res) => {
                    deferred.resolve(res.data);
                })
                .catch(() =>{
                    deferred.resolve([]);
                });
           return deferred.promise;
        }

    }

    angular.module('MW.Influencers.SendgridService', [
        'MW.Configuration',
    ])
        .service('SendgridService', [
            '$q',
            '$http',
            'SENDGRID_ACCOUNT_SERVICE_URL',
            SendgridService
        ]);
})();